import DeviceInfo from '@/modules/util/deviceInfo'

export const isPhoneGap = () => {
  return !!(window.cordova && window.cordova.version)
  // if (document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1) {
  //   return true
  // }
  // return true // comment when test native db in browser
}

export const isInAppPreviewer = () => {
  // let currentUserAgent = navigator.userAgent
  let WindowsAppPreviewer = ''
  let vars = []
  let hash
  let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&')
  for (let i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=')
    vars.push(hash[0])
    vars[hash[0]] = hash[1]
  }
  WindowsAppPreviewer = vars
  return (navigator.userAgent.indexOf('appPreviewer') !== -1 || WindowsAppPreviewer === 'appPreviewer')
}

export const isInIframe = () => {
  return parent !== self
}

export const IsReportingPage = () => {
  if (isInAppPreviewer() || isInIframe()) {
    return false
  } else if (isPhoneGap() || (DeviceInfo.isMobile || DeviceInfo.isTablet)) {
    return true
  } else if (!isInAppPreviewer() && (DeviceInfo.isAndroid || DeviceInfo.isIOS)) {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/modules/util/util.js